<h2 mat-dialog-title>{{ 'reorder_module' | transloco }}: {{ data.module.title }}</h2>

<mat-dialog-content>
    <div class="reorder-options">
        <mat-radio-group [(ngModel)]="placement" class="placement-group">
            <mat-radio-button value="first">{{ 'reorder_place_first' | transloco }}</mat-radio-button>
            <mat-radio-button value="after">{{ 'reorder_place_after' | transloco }}</mat-radio-button>
        </mat-radio-group>

        @if (placement === 'after') {
            <div class="module-select">
                <pixl-multi-combo-entity-search
                    [label]="'reorder_select_module' | transloco"
                    [observable$]="modules$"
                    [namingColumn]="'title'"
                    [externalSearch]="true"
                    [multiple]="false"
                    (onStateChange)="receiveModuleData($event)"
                    (onSearchChange)="receiveModuleQuery($event)"
                    (scrolledToEnd)="loadMoreModules($event)"
                    [(selectedValues)]="selectedModule"
                >
                </pixl-multi-combo-entity-search>
            </div>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ 'cancel' | transloco }}</button>
    <button mat-flat-button color="primary" [disabled]="!canConfirm" (click)="confirm()">
        {{ 'save' | transloco }}
    </button>
</mat-dialog-actions>
